import { useEffect } from 'react';
import { initJQueryPlugins } from './initJQueryPlugins';

/**
 * 다음 프레임 대기 유틸리티 함수
 */
const waitForNextFrame = () => {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        resolve();
      });
    });
  });
};

/**
 * 메가메뉴 이벤트 리스너 설정 및 jQuery 플러그인 초기화 커스텀 훅
 */
export const useMegaMenuListeners = () => {
  useEffect(() => {
    // 원본 mega-menu.js의 이벤트 리스너 완전 비활성화
    // useMegaMenu.js에서만 메가메뉴 이벤트를 제어하도록 함
    if (typeof window.megaMenu !== 'undefined' && window.megaMenu.setupEventListeners) {
      // 원본 이벤트 리스너를 완전히 비활성화 (빈 함수로 오버라이드)
      window.megaMenu.setupEventListeners = function() {
        // useMegaMenu.js에서 모든 메가메뉴 이벤트를 처리하므로 여기서는 아무것도 하지 않음
        return;
      };
    }

    // 초기 마운트 시 jQuery 플러그인 초기화 (경로 변경 시에는 useAOSRefresh에서 처리)
    // 초기 렌더링 완료 대기
    waitForNextFrame().then(() => {
      // jQuery 플러그인 초기화
      if (typeof window.jQuery !== 'undefined') {
        initJQueryPlugins();
      }

      // main.js의 초기화 함수가 있다면 호출 (DOMContentLoaded 대신)
      if (typeof window.initMainJS === 'function') {
        window.initMainJS();
      }
    });
  }, []);
};
